module.exports = __webpack_public_path__ + "static/media/robo-narrow.1d376457.png";